class ProductFeatures extends HTMLElement {
  constructor() {
    super();

    this.features = this.querySelectorAll(".feature-block");

    this.handleFeatureClick = this.onFeatureClick.bind(this);

    this.features.forEach((item) => {
      item
        .querySelector("button")
        .addEventListener("click", this.handleFeatureClick);
    });
  }

  toggleFeature(el) {
    let content = el
      .closest(".feature-block")
      .querySelector(".feature-content");

    let icon = el.closest(".feature-block").querySelector(".feature-icon");

    console.log("icon", icon);
    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden");
      icon.classList.remove("fa-plus");
      icon.classList.add("fa-minus");
    } else {
      content.classList.add("hidden");
      icon.classList.add("fa-plus");
      icon.classList.remove("fa-minus");
    }
  }

  onFeatureClick(evt) {
    const target = evt.target;

    console.log("handleCloseClick", target);

    this.toggleFeature(target);
  }
}

customElements.define("product-features", ProductFeatures);
